import React from 'react';

import { Dialog, LegacyText, Button } from '@gogame/components';

const ReleaseDialog = ({ open, onClose, onExited }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    document.location.reload();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onExited={onExited}
      onClose={onClose}
      disableEscapeKeyDown={true}
      fullWidth={true}
    >
      <Dialog.Title title={'GoGame update completed'} withoutClose={true} />
      <Dialog.Content>
        <LegacyText>We're done! Please reload page.</LegacyText>
      </Dialog.Content>
      <Dialog.Actions>
        <Button type={'button'} onClick={handleClose}>
          Close
        </Button>
        <Button type={'button'} onClick={handleSubmit}>
          Reload Page
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default ReleaseDialog;
